import Modal from "ui/Modal";
import LoginPanel from "../LoginPanel";
import {LoginModalProps} from "../../types/types";
import {useUserInfo} from "../../hooks";

export default function LoginModal({
                                       isOpen = false,
                                       width = 480,
                                       ...props
                                   }: LoginModalProps) {
    const {isLogin} = useUserInfo()
    return <Modal
        isOpen={isOpen && !isLogin}
        width={width}
    >
        <LoginPanel {...props} inModal/>
    </Modal>
}